export const PROFILE_DATA = {
  name: "Dante Ferraz",
  avatar: "https://2.gravatar.com/avatar/7e5efe45b0487e749d9dcd90a1b1800dc382ab859893b5ac499fbd95a1cbf803?size=512&d=initials",
  bio: "Apaixonado por tudo que tem motor e rodas! Sou Dante Ferraz, especialista em carros e motos, sempre de olho nas melhores dicas de segurança e proteção. Falo sobre seguros de auto e moto, mostrando como eles podem te dar tranquilidade e garantir que você aproveite cada viagem com segurança. Se você curte o mundo automotivo ou quer saber como proteger seu veículo, este é o lugar certo! Vamos acelerar juntos?"
} as const;

export const LINKS_DATA = [
  {
    title: "Gravatar",
    url: "https://gravatar.com/danteferrazblog"
  },
  {
    title: "Seguro Moto",
    url: "https://cotandoseguro.com/seguro-moto/"
  },
  {
    title: "Seguro Auto",
    url: "https://cotandoseguro.com/seguro-auto/"
  },
  {
    title: "Aluguel de Poltronas",
    url: "https://lklocacoes.com.br/categoria/aluguel-de-poltronas/"
  },
  {
    title: "Aluguel de Móveis para Eventos",
    url: "https://lklocacoes.com.br/aluguel-de-moveis-para-eventos/"
  },
  {
    title: "Tendência de corte de cabelo",
    url: "https://danidrops.com.br/category/cabelo/"
  }
] as const;
